import { Result } from "../models/Result";
import { httpService } from "./HttpService";

class PermissionService {

    baseApiUrl = process.env.REACT_APP_AUTH_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL;
    GetPermissions = async (): Promise<Result<string[]>> => {
        return await httpService.get<string[]>("/Permission", { baseURL: this.baseApiUrl });
    };
}

const permissionService = new PermissionService();

export { permissionService };